import { defineMessages } from 'react-intl'

const EbookMessages = {
  EbookProgramPageContent: defineMessages({
    tryOut: {
      id: 'page.ProgramContent.tryOut',
      defaultMessage: '試看',
    },
  }),
}

export default EbookMessages
